import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/app/Common";
import { api, errMsg } from "@/lib/api";

export const EnterpriseDialog = ({ open, onOpenChange }) => {
  const [f, setF] = useState({ name: "", email: "", company: "", entities: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/enterprise-inquiry", f);
      toast.success("Thanks — our team will reach out shortly.");
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="enterprise-dialog">
        <DialogHeader><DialogTitle>Talk to us about Enterprise</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Field label="Name"><Input required value={f.name} onChange={set("name")} data-testid="ent-name-input" /></Field>
          <Field label="Work email"><Input required type="email" value={f.email} onChange={set("email")} data-testid="ent-email-input" /></Field>
          <Field label="Company"><Input required value={f.company} onChange={set("company")} data-testid="ent-company-input" /></Field>
          <Field label="Number of entities"><Input value={f.entities} onChange={set("entities")} data-testid="ent-entities-input" /></Field>
          <Field label="What do you need?"><Textarea value={f.message} onChange={set("message")} data-testid="ent-message-input" /></Field>
          <Button type="submit" className="w-full" disabled={busy} data-testid="ent-submit-btn">Send enquiry</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
